import { FC } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/shared/ui/Dialog/Dialog'
import { AlertDialogProps } from '@radix-ui/react-alert-dialog'
import { AmenityType } from '@/shared/api/topli/TopliApi'
import { UploadPhotoForm } from '@/features/AmenityPhoto/UploadPhotoForm/ui/UploadPhotoForm'
import { useTranslation } from 'react-i18next'

type UploadedEditPhotoModalProps = {
  dialogProps: AlertDialogProps
  currenUnitAmenityId: number
  currentUnitAmenityName: string
  onCloseModal: () => void
  currentPictureUrl: string | null
  onRequestDeletePhoto: () => void
  onPhotoDeleted: () => void
}

export const UploadPhotoModal: FC<UploadedEditPhotoModalProps> = props => {
  const {
    dialogProps,
    currenUnitAmenityId,
    onCloseModal,
    currentPictureUrl,
    currentUnitAmenityName,
    onRequestDeletePhoto,
    onPhotoDeleted,
  } = props
  const { t } = useTranslation(['photo'])

  return (
    <Dialog {...dialogProps}>
      <DialogContent className={'flex flex-col overflow-y-auto h-full max-h-[40vh] min-w-[20vw]'}>
        <DialogHeader>
          <DialogTitle>{t('photo:photo')}</DialogTitle>
          <UploadPhotoForm
            selectAmenityId={currenUnitAmenityId}
            selectAmenityName={currentUnitAmenityName}
            type={AmenityType.Unit}
            onCloseModal={onCloseModal}
            currentPictureUrl={currentPictureUrl}
            onRequestDeletePhoto={onRequestDeletePhoto}
            onPhotoDeleted={onPhotoDeleted}
          />
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
